export default "__VITE_ASSET__c38c9db6__"